import React from 'react';
import '../template-file-css/document-file-template.css';


export const OTP_DiagnosticAssessment = ({
    itemsRef,
    showErrorFor,
}) => {

    return (
        <form id='OTP_DiagnosticAssessment' className='file-pdf-document'>
            <div className='file-template'>

                <p className='w-750'>
                    <span className='eleHeader'>Persons Present</span>
                    <textarea id='txtPersonsPresent' name='txtPersonsPresent' className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Reason for Assessment/Presenting Problems/ History of Presenting Problem</span>
                    <span className='small'>(Specific statement of Medical/mental health symptoms; frequency and duration of
                        conduct and behaviors, behaviors and concerns that would justify a referral for CORE or Intensive Services)</span>
                    <textarea id='txtPresentingProblem' name='txtPresentingProblem' className='add-only'></textarea>
                </p>

                <p className='w-750'><h2>Medical Screening/Health History</h2></p>
                <p className='w-750'><h5>Medical Exam</h5></p>

                <table>
                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbMedicalExam_None' name='cbMedicalExam_None' className='add-only' value='NoneReported' /> None Reported
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>Date</span>
                            <input type='date' id='txtMedicalExam_Date' name='txtMedicalExam_Date' className='add-only w-200 custom-add-only' />
                        </td>
                        <td className='w-375'>
                            <span className='eleHeader'>PCP name and location</span>
                            <input type='text' id='txtMedicalExam_NameLoc' name='txtMedicalExam_NameLoc' className='add-only' />
                        </td>
                    </tr>
                </table>

                <p className='w-750'><h5>Dental Exam</h5></p>

                <table>
                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbDentalExam_None' name='cbDentalExam_None' className='add-only' value='NoneReported' /> None Reported
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>Date</span>
                            <input type='date' id='txtDentalExam_Date' name='txtDentalExam_Date' className='add-only w-200 custom-add-only' />
                        </td>
                        <td className='w-375'>
                            <span className='eleHeader'>DMD name and location</span>
                            <input type='text' id='txtDentalExam_NameLoc' name='txtDentalExam_NameLoc' className='add-only' />
                        </td>
                    </tr>
                </table>

                <p className='w-750'><h5>Psychological Evaluation</h5></p>

                <table>
                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbPsychEval_None' name='cbPsychEval_None' className='add-only' value='NoneReported' /> None Reported
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>Date</span>
                            <input type='date' id='txtPsychEval_Date' name='txtPsychEval_Date' className='add-only w-200 custom-add-only' />
                        </td>
                        <td className='w-375'>
                            <span className='eleHeader'>Provider name and location</span>
                            <input type='text' id='txtPsychEval_NameLoc' name='txtPsychEval_NameLoc' className='add-only' />
                        </td>
                    </tr>
                </table>

                <p className='w-750'><h5>Psychiatric Evaluation</h5></p>

                <table>
                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbPsychiatricEval_None' name='cbPsychiatricEval_None' className='add-only' value='NoneReported' /> None Reported
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>Date</span>
                            <input type='date' id='txtPsychiatricEval_Date' name='txtPsychiatricEval_Date' className='add-only w-200 custom-add-only' />
                        </td>
                        <td className='w-375'>
                            <span className='eleHeader'>Provider name and location</span>
                            <input type='text' id='txtPsychiatricEval_NameLoc' name='txtPsychiatricEval_NameLoc' className='add-only' />
                        </td>
                    </tr>
                </table>

                <p className='w-750'>
                    <h5>Medical Complaints</h5>
                    <input type='checkbox' id='cbMedComplaints_None' name='cbMedComplaints_None' className='add-only' value='NoneReported' /> None Reported
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Current Complaints</span>
                    <textarea id='txtMedComplaints' name='txtMedComplaints' className='add-only'></textarea>
                </p>

                <p className='w-750'>
                    <h5>Current Medications</h5>
                    <input type='checkbox' id='cbCurrMeds_None' name='cbCurrMeds_None' className='add-only' value='NoneReported' /> None Reported
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Current medications</span>
                    <span className='small'>(include dosage, prescribing doctor, purpose, and duration)</span>
                    <textarea id='txtCurrMeds' name='txtCurrMeds' className='add-only'></textarea>
                </p>

                <p className='w-750'>
                    <h5>Past Medications</h5>
                    <input type='checkbox' id='cbPastMeds_None' name='cbPastMeds_None' className='add-only' value='NoneReported' /> None Reported
                </p>

                <p className='w-750'>
                    <span className='eleHeader'>Past medications</span>
                    <span className='small'>(include dosage, prescribing doctor, purpose, and duration)</span>
                    <textarea id='txtPastMeds' name='txtPastMeds' className='add-only'></textarea>
                </p>

                <p className='w-750'>
                    <h5>Mental Health/Psychiatric History</h5>
                    <input type='checkbox' id='cbMhHistory_None' name='cbMhHistory_None' className='add-only' value='NoneReported' /> None Reported
                </p>

                <p className='w-750'>
                    <span className='eleHeader'>Name of provider, duration of treatment, diagnosis, date, issues</span>
                    <span className='small'>(include history of counseling, dates, and reason)</span>
                    <textarea id='txtMhHistory' name='txtMhHistory' className='add-only'></textarea>
                </p>

                <p className='w-750'><span className='eleHeader'>Eating Patterns</span></p>

                <p className='w-750'>
                    <span className='small'>(eating disorders, appetite)</span>
                    <textarea id='txtEatingPatterns' name='txtEatingPatterns' className='add-only'></textarea>
                </p>

                <p className='w-750'><span className='eleHeader'>Sleeping Patterns</span></p>

                <p className='w-750'>
                    <span className='small'>(insomnia, oversleeping)</span>
                    <textarea id='txtSleepingPatterns' name='txtSleepingPatterns' className='add-only'></textarea>
                </p>

                <p className='w-750'><span className='eleHeader'>Allergies</span></p>

                <p className='w-750'>
                    <input type='checkbox' id='cbAllergy_None' name='cbAllergy_None' className='add-only' value='NoneReported' /> None Reported<br />
                    <input type='checkbox' id='cbAllergy_Med' name='cbAllergy_Med' className='add-only' value='Medication' /> Medication<br />
                    <textarea id='txtAllergies_Med' name='txtAllergies_Med' className='add-only'></textarea><br />
                    <input type='checkbox' id='cbAllergy_Food' name='cbAllergy_Food' className='add-only' value='Food' /> Food<br />
                    <textarea id='txtAllergies_Food' name='txtAllergies_Food' className='add-only'></textarea><br />
                    <input type='checkbox' id='cbAllergy_Pet' name='cbAllergy_Pet' className='add-only' value='SeasonalPets' /> Seasonal/Pets<br />
                    <textarea id='txtAllergies_Pet' name='txtAllergies_Pet' className='add-only'></textarea>
                </p>

                <p className='w-750'>
                    <span className='eleHeader'>Deficits</span>
                    <span className='small'>(glasses, hearing aids, walker)</span>
                </p>
                <p className='w-750'>
                    <input type='checkbox' id='cbDeficits_None' name='cbDeficits_None' className='add-only' value='NoneReported' /> None Reported<br />
                    <input type='checkbox' id='cbDeficits_Hearing' name='cbDeficits_Hearing' className='add-only' value='Hearing' /> Hearing<br />
                    <textarea id='txtDeficits_Hearing' name='txtDeficits_Hearing' className='add-only'></textarea><br />
                    <input type='checkbox' id='cbDeficits_Seeing' name='cbDeficits_Seeing' className='add-only' value='Seeing' /> Seeing<br />
                    <textarea id='txtDeficits_Seeing' name='txtDeficits_Seeing' className='add-only'></textarea><br />
                    <input type='checkbox' id='cbDeficits_Speech' name='cbDeficits_Speech' className='add-only' value='Speech' /> Speech<br />
                    <textarea id='txtDeficits_Speech' name='txtDeficits_Speech' className='add-only'></textarea>
                </p>

                <p className='w-750'>
                    <span className='eleHeader'>Immunizations</span>
                    <input type='checkbox' id='cbImmunizations_Yes' name='cbImmunizations' className='add-only' value='Yes' /> Yes &nbsp;
                    <input type='checkbox' id='cbImmunizations_No' name='cbImmunizations' className='add-only' value='No' /> No
                </p>

                <p className='w-750'>
                    <span className='eleHeader'>Medical Problems</span>
                    <span className='small'>(Heart Disease, Lung Disease, Cancer, Strokes, Dementia, Diabetes, Asthma)</span>
                    <input type='checkbox' id='cbMedProbs_None' name='cbMedProbs_None' className='add-only' value='NoneReported' /> None Reported<br />
                    <input type='checkbox' id='cbMedProbs_Specify' name='cbMedProbs_Specify' className='add-only' value='SpecifyPersonProblem' /> Specify person and problem<br />
                    <textarea id='txtMedicalProblems' name='txtMedicalProblems' className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Substance Abuse</span>
                    <span className='small'>(Alcohol,Cocaine, Cannabis, Stimulants, Inhalants, Hallucinogens, Sedatives, Designer Drugs)</span>
                    <input type='checkbox' id='cbSa_None' name='cbSa_None' className='add-only' value='NoneReported' /> None Reported<br />
                    <input type='checkbox' id='cbSa_Specify' name='cbSa_Specify' className='add-only' value='SpecifyPersonProblem' /> Specify person and problem<br />
                    <textarea id='txtSa' name='txtSa' className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Mental Illness</span>
                    <span className='small'>(Depression, Schizophrenia, Bipolar disorder, Anxiety, ADD, ADHD,
                        Learning Disorders, School Behavior Problems, Incarcerations, Gambling)</span>
                    <input type='checkbox' id='cbMentalIllness_None' name='cbMentalIllness_None' className='add-only' value='NoneReported' /> None Reported<br />
                    <input type='checkbox' id='cbMentalIllness_Specify' name='cbMentalIllness_Specify' className='add-only' value='SpecifyPersonProblem' /> Specify person and problem<br />
                    <textarea id='txtMentalIllness' name='txtMentalIllness' className='add-only'></textarea>
                </p>

                <p className='w-750'>
                    <h2>Psycho-Social
                        <span className='small'>(identify duration, intensity, frequency, dates, history, triggers, treatment)</span></h2>
                </p>

                <table>
                    <tr>
                        <td className='w-750'><span className='eleHeader'>Suicidal Ideation</span></td>
                    </tr>
                    <tr>
                        <td className='w-250'><input type='checkbox' id='cbSuicidal_None' name='cbSuicidal_None' className='add-only' value='NoneReported' /> None Reported</td>
                        <td className='w-250'><input type='checkbox' id='cbSuicidal_Past' name='cbSuicidal_Past' className='add-only' value='Past' /> Past</td>
                        <td className='w-250'><input type='checkbox' id='cbSuicidal_Current' name='cbSuicidal_Current' className='add-only' value='Current' /> Current</td>
                    </tr>
                </table>

                <p className='w-750'>
                    Describe<br />
                    <textarea id='txtSuicidalCurrent' name='txtSuicidalCurrent' className='add-only'></textarea>
                </p>

                <table>
                    <tr>
                        <td className='w-750'><span className='eleHeader'>Self-Mutilation/Cutting</span></td>
                    </tr>
                    <tr>
                        <td className='w-250'><input type='checkbox' id='cbCutting_None' name='cbCutting_None' className='add-only' value='NoneReported' /> None Reported</td>
                        <td className='w-250'><input type='checkbox' id='cbCutting_Past' name='cbCutting_Past' className='add-only' value='Past' /> Past</td>
                        <td className='w-250'><input type='checkbox' id='cbCutting_Current' name='cbCutting_Current' className='add-only' value='Current' /> Current</td>
                    </tr>
                </table>
                <p className='w-750'>
                    Describe<br />
                    <textarea id='txtCuttingCurrent' name='txtCuttingCurrent' className='add-only'></textarea>
                </p>
                <table>
                    <tr>
                        <td className='w-750'><span className='eleHeader'>Homicidal Ideation</span></td>
                    </tr>
                    <tr>
                        <td className='w-250'><input type='checkbox' id='cbHomicidal_None' name='cbHomicidal_None' className='add-only' value='NoneReported' /> None Reported</td>
                        <td className='w-250'><input type='checkbox' id='cbHomicidal_Past' name='cbHomicidal_Past' className='add-only' value='Past' /> Past</td>
                        <td className='w-250'><input type='checkbox' id='cbHomicidal_Current' name='cbHomicidal_Current' className='add-only' value='Current' /> Current</td>
                    </tr>
                </table>

                <p className='w-750'>
                    Describe<br />
                    <textarea id='txtHomicidalCurrent' name='txtHomicidalCurrent' className='add-only'></textarea>
                </p>

                <table>
                    <tr>
                        <td className='w-750'><span className='eleHeader'>Delusions/Hallucinations</span></td>
                    </tr>
                    <tr>
                        <td className='w-250'><input type='checkbox' id='cbDelusions_None' name='cbDelusions_None' className='add-only' value='NoneReported' /> None Reported</td>
                        <td className='w-250'><input type='checkbox' id='cbDelusions_Past' name='cbDelusions_Past' className='add-only' value='Past' /> Past</td>
                        <td className='w-250'><input type='checkbox' id='cbDelusions_Current' name='cbDelusions_Current' className='add-only' value='Current' /> Current</td>
                    </tr>
                </table>

                <p className='w-750'>
                    Describe<br />
                    <textarea id='txtDelusionsCurrent' name='txtDelusionsCurrent' className='add-only'></textarea>
                </p>

                <table>
                    <tr>
                        <td className='w-750'><span className='eleHeader'>OCD Behaviors</span></td>
                    </tr>
                    <tr>
                        <td className='w-250'><input type='checkbox' id='cbOcd_None' name='cbOcd_None' className='add-only' value='NoneReported' /> None Reported</td>
                        <td className='w-250'><input type='checkbox' id='cbOcd_Past' name='cbOcd_Past' className='add-only' value='Past' /> Past</td>
                        <td className='w-250'><input type='checkbox' id='cbOcd_Current' name='cbOcd_Current' className='add-only' value='Current' /> Current</td>
                    </tr>
                </table>

                <p className='w-750'>
                    Describe<br />
                    <textarea id='txtOCDCurrent' name='txtOCDCurrent' className='add-only'></textarea>
                </p>

                <p className='w-750'>
                    <span className='eleHeader'>PTSD Symptoms</span>
                    <span className='small'>(terrors, flashbacks)</span>
                    <input type='checkbox' id='cbPtsd_None' name='cbPtsd_None' className='add-only' value='NoneReported' /> None Reported<br />
                    <input type='checkbox' id='cbPtsd_Current' name='cbPtsd_Current' className='add-only' value='Specify' /> Specify<br />
                    <textarea id='txtPTSDCurrent' name='txtPTSDCurrent' className='add-only'></textarea>
                </p>
                <table>
                    <tr>
                        <td className='w-750'><span className='eleHeader'>Temper Tantrums/Rapid Mood Swings</span></td>
                    </tr>
                    <tr>
                        <td className='w-250'><input type='checkbox' id='cbTemper_None' name='cbTemper_None' className='add-only' value='NoneReported' /> None Reported</td>
                        <td className='w-250'><input type='checkbox' id='cbTemper_Past' name='cbTemper_Past' className='add-only' value='Past' /> Past</td>
                        <td className='w-250'><input type='checkbox' id='cbTemper_Current' name='cbTemper_Current' className='add-only' value='Current' /> Current</td>
                    </tr>
                </table>

                <p className='w-750'>
                    Describe<br />
                    <textarea id='txtTemperCurrent' name='txtTemperCurrent' className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Aggressive Behavior</span>
                    <input type='checkbox' id='cbAggressive_None' name='cbAggressive_None' className='add-only' value='NoneReported' /> None Reported<br />
                    <input type='checkbox' id='cbAggressive_Current' name='cbAggressive_Current' className='add-only' value='Specify' /> Specify<br />
                    <textarea id='txtAggressiveCurrent' name='txtAggressiveCurrent' className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Oppositional Behavior</span>
                    <input type='checkbox' id='cbOppositional_None' name='cbOppositional_None' className='add-only' value='NoneReported' /> None Reported<br />
                    <input type='checkbox' id='cbOppositional_Current' name='cbOppositional_Current' className='add-only' value='Specify' /> Specify<br />
                    <textarea id='txtOppositionalCurrent' name='txtOppositionalCurrent' className='add-only'></textarea>
                </p>
                <table>
                    <tr>
                        <td className='w-750'><span className='eleHeader'>Sexualized Behavior</span></td>
                    </tr>
                    <tr>
                        <td className='w-250'><input type='checkbox' id='cbSexualized_None' name='cbSexualized_None' className='add-only' value='NoneReported' /> None Reported</td>
                        <td className='w-250'><input type='checkbox' id='cbSexualized_Past' name='cbSexualized_Past' className='add-only' value='SexualPromiscuity' /> Sexual promiscuity</td>
                        <td className='w-250'><input type='checkbox' id='cbSexualized_Current' name='cbSexualized_Current' className='add-only' value='Prostitution' /> Prostitution</td>
                    </tr>
                    <tr>
                        <td className='w-250'><input type='checkbox' id='cbStdsPregnancies' name='cbStdsPregnancies' className='add-only' value='StdsPregnancies' /> STD's and pregnancies</td>
                        <td className='w-500'><input type='checkbox' id='cbAtRiskBehaviors' name='cbAtRiskBehaviors' className='add-only' value='AtRiskBehaviors' /> At-risk behaviors (unprotected sex)</td>
                    </tr>
                </table>

                <p className='w-750'>
                    Describe<br />
                    <textarea id='txtSexualizedCurrent' name='txtSexualizedCurrent' className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Sexual Perpetrator</span>
                    <input type='checkbox' id='cbSexualPerp_None' name='cbSexualPerp_None' className='add-only' value='NoneReported' /> None Reported<br />
                    Specify intensity, type, date of last incident, active charges, history of treatment, current sexual supervision plan (DJJ)<br />
                    <textarea id='txtSexualPerp' name='txtSexualPerp' className='add-only'></textarea>
                </p>
                <table>
                    <tr>
                        <td className='w-750'><span className='eleHeader'>History of Abuse</span></td>
                    </tr>
                    <tr>
                        <td className='w-250'><input type='checkbox' id='cbHistAbuse_None' name='cbHistAbuse_None' className='add-only' value='NoneReported' /> None Reported</td>
                        <td className='w-250'><input type='checkbox' id='cbHistAbuse_Sexual' name='cbHistAbuse_Sexual' className='add-only' value='Sexual' /> Sexual</td>
                        <td className='w-250'><input type='checkbox' id='cbHistAbuse_Physical' name='cbHistAbuse_Physical' className='add-only' value='Physical' /> Physical</td>
                    </tr>
                    <tr>
                        <td className='w-250'><input type='checkbox' id='cbHistAbuse_Emotional' name='cbHistAbuse_Emotional' className='add-only' value='Emotional' /> Emotional</td>
                        <td className='w-250'><input type='checkbox' id='cbHistAbuse_Neglect' name='cbHistAbuse_Neglect' className='add-only' value='Neglect' /> Neglect</td>
                        <td className='w-250'><input type='checkbox' id='cbHistAbuse_Domestic' name='cbHistAbuse_Domestic' className='add-only' value='DomesticViolence' /> Domestic Violence (Witness)</td>
                    </tr>
                </table>

                <p className='w-750'>
                    Describe:<br />
                    <textarea id='txtHistAbuse' name='txtHistAbuse' className='add-only'></textarea>
                </p>

                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>School History</span>
                            <span className='small'>{`(Include  brief history of schools attended; any retentions/grade(s); special services i.e.
                                SST or Speech; general conduct, relationships with authority and peers; academic goals and attendance trends;
                                extra-curriculum activities; present school)`}</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='checkbox' id='cbSchoolHistory_Mainstream' name='cbSchoolHistory_Mainstream' className='add-only' value='MainstreamSchool' /> Mainstream School
                        </td>
                        <td className='w-375'>
                            <input type='checkbox' id='cbSchoolHistory_Alternative' name='cbSchoolHistory_Alternative' className='add-only' value='AlternativeSchool' /> Alternative School
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='checkbox' id='cbSchoolHistory_PsychEd' name='cbSchoolHistory_PsychEd' className='add-only' value='PsychoEducationalProgram' /> Psycho-educational Program
                        </td>
                        <td className='w-375'>
                            <input type='checkbox' id='cbSchoolHistory_Out' name='cbSchoolHistory_Out' className='add-only' value='OutSchool' /> Out of School
                        </td>
                    </tr>
                </table>

                <p className='w-750'>
                    <textarea id='txtSchoolHistory' name='txtSchoolHistory' className='add-only'></textarea>
                </p>

                <p className='w-750'><h2>Substance Abuse Assessment</h2></p>

                <table>
                    <tr>
                        <td className='w-150'><span className='eleHeader'>Substance Name</span></td>
                        <td className='w-150'><span className='eleHeader'>Age of 1st Use</span></td>
                        <td className='w-150'><span className='eleHeader'>Date of Last Use</span></td>
                        <td className='w-150'><span className='eleHeader'>Frequency/Amount</span></td>
                        <td className='w-150'><span className='eleHeader'>Longest Period of Sobriety</span></td>
                    </tr>
                    <tr>
                        <td className='w-150'>Alcohol</td>
                        <td className='w-150'><input type='text' id='txtSaa_Alcohol1' name='txtSaa_Alcohol1' className='add-only' /></td>
                        <td className='w-150'><input type='date' id='txtSaa_Alcohol2' name='txtSaa_Alcohol2' className='add-only' /></td>
                        <td className='w-150'><input type='text' id='txtSaa_Alcohol3' name='txtSaa_Alcohol3' className='add-only' /></td>
                        <td className='w-150'><input type='text' id='txtSaa_Alcohol4' name='txtSaa_Alcohol4' className='add-only' /></td>
                    </tr>
                    <tr>
                        <td className='w-750'><hr /></td>
                    </tr>
                    <tr>
                        <td className='w-150'>Cannabis</td>
                        <td className='w-150'><input type='text' id='txtSaa_Cannabis1' name='txtSaa_Cannabis1' className='add-only' /></td>
                        <td className='w-150'><input type='date' id='txtSaa_Cannabis2' name='txtSaa_Cannabis2' className='add-only' /></td>
                        <td className='w-150'><input type='text' id='txtSaa_Cannabis3' name='txtSaa_Cannabis3' className='add-only' /></td>
                        <td className='w-150'><input type='text' id='txtSaa_Cannabis4' name='txtSaa_Cannabis4' className='add-only' /></td>
                    </tr>
                    <tr>
                        <td className='w-750'><hr /></td>
                    </tr>
                    <tr>
                        <td className='w-150'>Cocaine</td>
                        <td className='w-150'><input type='text' id='txtSaa_Cocaine1' name='txtSaa_Cocaine1' className='add-only' /></td>
                        <td className='w-150'><input type='date' id='txtSaa_Cocaine2' name='txtSaa_Cocaine2' className='add-only' /></td>
                        <td className='w-150'><input type='text' id='txtSaa_Cocaine3' name='txtSaa_Cocaine3' className='add-only' /></td>
                        <td className='w-150'><input type='text' id='txtSaa_Cocaine4' name='txtSaa_Cocaine4' className='add-only' /></td>
                    </tr>
                    <tr>
                        <td className='w-750'><hr /></td>
                    </tr>
                    <tr>
                        <td className='w-150'>Stimulants</td>
                        <td className='w-150'><input type='text' id='txtSaa_Stimulants1' name='txtSaa_Stimulants1' className='add-only' /></td>
                        <td className='w-150'><input type='date' id='txtSaa_Stimulants2' name='txtSaa_Stimulants2' className='add-only' /></td>
                        <td className='w-150'><input type='text' id='txtSaa_Stimulants3' name='txtSaa_Stimulants3' className='add-only' /></td>
                        <td className='w-150'><input type='text' id='txtSaa_Stimulants4' name='txtSaa_Stimulants4' className='add-only' /></td>
                    </tr>
                    <tr>
                        <td className='w-750'><hr /></td>
                    </tr>
                    <tr>
                        <td className='w-150'>Methamphetamine</td>
                        <td className='w-150'><input type='text' id='txtSaa_Meth1' name='txtSaa_Meth1' className='add-only' /></td>
                        <td className='w-150'><input type='date' id='txtSaa_Meth2' name='txtSaa_Meth2' className='add-only' /></td>
                        <td className='w-150'><input type='text' id='txtSaa_Meth3' name='txtSaa_Meth3' className='add-only' /></td>
                        <td className='w-150'><input type='text' id='txtSaa_Meth4' name='txtSaa_Meth4' className='add-only' /></td>
                    </tr>
                    <tr>
                        <td className='w-750'><hr /></td>
                    </tr>
                    <tr>
                        <td className='w-150'>LSD/PCP/Mushrooms</td>
                        <td className='w-150'><input type='text' id='txtSaa_Lsd1' name='txtSaa_Lsd1' className='add-only' /></td>
                        <td className='w-150'><input type='date' id='txtSaa_Lsd2' name='txtSaa_Lsd2' className='add-only' /></td>
                        <td className='w-150'><input type='text' id='txtSaa_Lsd3' name='txtSaa_Lsd3' className='add-only' /></td>
                        <td className='w-150'><input type='text' id='txtSaa_Lsd4' name='txtSaa_Lsd4' className='add-only' /></td>
                    </tr>
                    <tr>
                        <td className='w-750'><hr /></td>
                    </tr>
                    <tr>
                        <td className='w-150'>Heroine/Methadone</td>
                        <td className='w-150'><input type='text' id='txtSaa_Heroine1' name='txtSaa_Heroine1' className='add-only' /></td>
                        <td className='w-150'><input type='date' id='txtSaa_Heroine2' name='txtSaa_Heroine2' className='add-only' /></td>
                        <td className='w-150'><input type='text' id='txtSaa_Heroine3' name='txtSaa_Heroine3' className='add-only' /></td>
                        <td className='w-150'><input type='text' id='txtSaa_Heroine4' name='txtSaa_Heroine4' className='add-only' /></td>
                    </tr>
                    <tr>
                        <td className='w-750'><hr /></td>
                    </tr>
                    <tr>
                        <td className='w-150'>Steroids/Cough Syrup</td>
                        <td className='w-150'><input type='text' id='txtSaa_Steroids1' name='txtSaa_Steroids1' className='add-only' /></td>
                        <td className='w-150'><input type='date' id='txtSaa_Steroids2' name='txtSaa_Steroids2' className='add-only' /></td>
                        <td className='w-150'><input type='text' id='txtSaa_Steroids3' name='txtSaa_Steroids3' className='add-only' /></td>
                        <td className='w-150'><input type='text' id='txtSaa_Steroids4' name='txtSaa_Steroids4' className='add-only' /></td>
                    </tr>
                    <tr>
                        <td className='w-750'><hr /></td>
                    </tr>
                    <tr>
                        <td className='w-150'>Tobacco</td>
                        <td className='w-150'><input type='text' id='txtSaa_Tobacco1' name='txtSaa_Steroids1' className='add-only' /></td>
                        <td className='w-150'><input type='date' id='txtSaa_Tobacco2' name='txtSaa_Tobacco2' className='add-only' /></td>
                        <td className='w-150'><input type='text' id='txtSaa_Tobacco3' name='txtSaa_Tobacco3' className='add-only' /></td>
                        <td className='w-150'><input type='text' id='txtSaa_Tobacco4' name='txtSaa_Tobacco4' className='add-only' /></td>
                    </tr>
                    <tr>
                        <td className='w-750'><hr /></td>
                    </tr>
                    <tr>
                        <td className='w-150'>Prescription Meds</td>
                        <td className='w-150'><input type='text' id='txtSaa_RxMeds1' name='txtSaa_RxMeds1' className='add-only' /></td>
                        <td className='w-150'><input type='date' id='txtSaa_RxMeds2' name='txtSaa_RxMeds2' className='add-only' /></td>
                        <td className='w-150'><input type='text' id='txtSaa_RxMeds3' name='txtSaa_RxMeds3' className='add-only' /></td>
                        <td className='w-150'><input type='text' id='txtSaa_RxMeds4' name='txtSaa_RxMeds4' className='add-only' /></td>
                    </tr>
                </table>

                <p className='w-750'>
                    <span className='eleHeader'>Social Stressors</span>
                    <span className='small'>Briefly describe</span>
                    <input type='checkbox' id='cbSocial_1' name='cbSocial_1' className='add-only' value='ProblemsPrimarySupportGroup' />
                    Problems with primary support group
                    <textarea id='txtSocial_1' name='txtSocial_1' className='add-only'></textarea>
                </p>

                <p className='w-750'>
                    <input type='checkbox' id='cbSocial_2' name='cbSocial_2' className='add-only' value='ProblemsRelatedSocialEnvironment' />
                    Problems related to social environment
                    <textarea id='txtSocial_2' name='txtSocial_2' className='add-only'></textarea>
                </p>

                <p className='w-750'>
                    <input type='checkbox' id='cbSocial_3' name='cbSocial_3' className='add-only' value='EducationalProblems' />
                    Educational problems
                    <textarea id='txtSocial_3' name='txtSocial_3' className='add-only'></textarea>
                </p>

                <p className='w-750'>
                    <input type='checkbox' id='cbSocial_4' name='cbSocial_4' className='add-only' value='OccupationalProblems' />
                    Occupational problems
                    <textarea id='txtSocial_4' name='txtSocial_4' className='add-only'></textarea>
                </p>

                <p className='w-750'>
                    <input type='checkbox' id='cbSocial_5' name='cbSocial_5' className='add-only' value='HousingProblems' />
                    Housing problems
                    <textarea id='txtSocial_5' name='txtSocial_5' className='add-only'></textarea>
                </p>

                <p className='w-750'>
                    <input type='checkbox' id='cbSocial_6' name='cbSocial_6' className='add-only' value='EconomicProblems' />
                    Economic problems
                    <textarea id='txtSocial_6' name='txtSocial_6' className='add-only'></textarea>
                </p>

                <p className='w-750'>
                    <input type='checkbox' id='cbSocial_7' name='cbSocial_7' className='add-only' value='ProblemsAccessHealthAervices' />
                    Problems with access to health care services
                    <textarea id='txtSocial_7' name='txtSocial_7' className='add-only'></textarea>
                </p>

                <p className='w-750'>
                    <input type='checkbox' id='cbSocial_8' name='cbSocial_8' className='add-only' value='OtherPsychosocialEnvironmentalProblems' />
                    Other psychosocial or environmental problems
                    <textarea id='txtSocial_8' name='txtSocial_8' className='add-only'></textarea>
                </p>

                <p className='w-750'><h2>Medical Problems/Mental Health Problems</h2></p>

                <p className='w-750'>
                    <span className='eleHeader'>(1)</span>
                    <textarea id='txtMedProblems_1' name='txtMedProblems_1' className='add-only'></textarea>
                </p>

                <p className='w-750'>
                    <span className='eleHeader'>(2)</span>
                    <textarea id='txtMedProblems_2' name='txtMedProblems_2' className='add-only'></textarea>
                </p>

                <p className='w-750'>
                    <span className='eleHeader'>(3)</span>
                    <textarea id='txtMedProblems_3' name='txtMedProblems_3' className='add-only'></textarea>
                </p>

                <p className='w-750'>
                    <span className='eleHeader'>(4)</span>
                    <textarea id='txtMedProblems_4' name='txtMedProblems_4' className='add-only'></textarea>
                </p>

                <p className='w-750'>
                    <span className='eleHeader'>(5)</span>
                    <textarea id='txtMedProblems_5' name='txtMedProblems_5' className='add-only'></textarea>
                </p>

                <p className='w-750'>
                    <h2>Recommendations</h2>
                    <span className='small'>
                        (What services will On The Path provide to address problems such as individual and
                        family counseling, substance abuse counseling, community resource linkage, academic assistance,
                        psychiatric evaluation and medication maintenance, diagnostic assessment, nursing assessment, etc)
                    </span>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>(1)</span>
                    <textarea id='txtRecommendations_1' name='txtRecommendations_1' className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>(2)</span>
                    <textarea id='txtRecommendations_2' name='txtRecommendations_2' className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>(3)</span>
                    <textarea id='txtRecommendations_3' name='txtRecommendations_3' className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>(4)</span>
                    <textarea id='txtRecommendations_4' name='txtRecommendations_4' className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>(5)</span>
                    <textarea id='txtRecommendations_5' name='txtRecommendations_5' className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>(6)</span>
                    <textarea id='txtRecommendations_6' name='txtRecommendations_6' className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>(7)</span>
                    <textarea id='txtRecommendations_7' name='txtRecommendations_7' className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Interpretative Summary:</span>
                    <span className='small'>Include an brief analysis of the consumer's symptoms; consumer's perception
                        of his/her need for services, interventions that On The Path can offer and community-based needs;
                        include psychological recommendations, diagnosis information and criteria met.</span>
                    <textarea id='txtInterpretativeSummary' name='txtInterpretativeSummary' className='add-only'></textarea>
                </p>

                <p className='w-750'><h2>Diagnostic Impression (DSM-IV)</h2></p>

                <table>
                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>AXIS I:</span>
                            <input type='text' id='txtAxisI' name='txtAxisI' className='add-only' />
                        </td>
                        <td className='w-375'>
                            <span className='eleHeader'>AXIS II:</span>
                            <input type='text' id='txtAxisII' name='txtAxisII' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>AXIS III:</span>
                            <input type='text' id='txtAxisIII' name='txtAxisIII' className='add-only' />
                        </td>
                        <td className='w-375'>
                            <span className='eleHeader'>AXIS IV:</span>
                            <input type='text' id='txtAxisIV' name='txtAxisIV' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>AXIS V - GAF (Current):</span>
                            <input type='text' id='txtAxisV' name='txtAxisV' className='add-only' />
                        </td>
                    </tr>
                </table>

                <p className='w-750'>
                    <span className='eleHeader'>Remarks:</span>
                    <textarea id='txtRemarks' name='txtRemarks' className='add-only'></textarea>
                </p>

                <table>
                    <tr>
                        <td className='signature w-275'></td>
                        <td className='signature w-275'></td>
                        <td className='signature w-130'></td>
                    </tr>

                    <tr>
                        <td className='small w-275'>Physician's Signature</td>
                        <td className='small w-275'>Physician's Printed Name & Credentials</td>
                        <td className='small w-130'>Date</td>
                    </tr>
                </table>



            </div>
        </form>

    )
}  
